<div class="bg-agent-layout super-admin float-start h-100 no-side-bar">
  <div class="b-color-100 border bg-agent-layout float-start h-100 side-bar">
    <h3 class="d-flex text-primary float-start font-large h3-font f-w-500 lh-1 ms-3 mb-2">
      <b> {{ superadminLabel }}</b>
    </h3>
    <div class="pb-2 float-start d-flex w-100">
      <div class="float-start w-100">
        <div class="px-1 d-flex">
          <i class="fal fa-sort-amount-up-alt m-2 text-primary" aria-hidden="true" *ngIf="sortOrder == 'ASC'"
            data-bs-toggle="tooltip" data-bs-placement="top" title="{{sortAgentsLabel}}"
            (click)="sortAgentsByDateArray()"></i>
          <i class="fal fa-sort-amount-down-alt m-2 text-primary" aria-hidden="true" *ngIf="sortOrder == 'DESC'"
            title="{{sortAgentsLabel}}" data-bs-toggle="tooltip" data-bs-placement="top"
            (click)="sortAgentsByDateArray()"></i>
          <div class="input-group search-container">
            <input type="text" class="form-control search-bar rounded-pill text-break" placeholder="{{searchLabel}}"
              aria-label="Search" maxlength="30" [(ngModel)]="searchviolationList" aria-describedby="basic-addon2">
            <div class="input-group-append search-icon">
              <div class="btn"
                style="padding: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;">
                <i class="fas fa-search"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div [ngClass]="hideLoading ? 'd-block': 'd-none'"
      class="p-2 overflow-auto custom-area height-90vh float-start w-100">
      <div #scrollContainerRef1 class="text-center">
        <img *ngIf="!agentViolationList.length" alt="No Data" class="w-100" src="assets/images/no-data.svg" />
        <p *ngIf="!agentViolationList.length" class="text-primary mt--20">{{noEscalatedEventsLabel}}</p>
        <app-voilation-list
          [violationList]="paginationViolationList | violationFilter:searchviolationList"></app-voilation-list>
      </div>
      <div class="col-md-12 w-100 text-center float-start pagination"
        [ngClass]="paginationViolationList && paginationViolationList.length > 0 ? '': 'd-none'">
        <pagination-template #p1="paginationApi" id="paginationid1" (pageChange)="pageChanged($event)" class="m-auto">
          <ul class="ngx-pagination responsive">
            <li><span class="pagesize-title">{{itemsPerPageLabel}}</span></li>
            <li>
              <select [ngModel]="config.itemsPerPage" (ngModelChange)="pageSizeChange($event)"
                class="pagesize form-select">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
              </select>
            </li>
            <li class="pagination-previous" [class.disabled]="p1.isFirstPage()">
              <a *ngIf="!p1.isFirstPage()" (click)="p1.previous()"> {{previousLabel}} </a>
            </li>
            <li *ngFor="let page of p1.pages" [class.current]="p1.getCurrent() === page.value">
              <a (click)="p1.setCurrent(page.value)" *ngIf="p1.getCurrent() !== page.value">
                <span>{{ page.label }}</span>
              </a>
              <div *ngIf="p1.getCurrent() === page.value">
                <span>{{ page.label }}</span>
              </div>
            </li>
            <li class="small-screen">{{p1.getCurrent()}} / {{totalPages}}</li>
            <li class="pagination-next" [class.disabled]="p1.isLastPage()">
              <a *ngIf="!p1.isLastPage()" (click)="p1.next()"> {{nextLabel}} </a>
            </li>
          </ul>
          <ul style="display: none">
            <li *ngFor="let item of agentViolationList | paginate: config">
            </li>
          </ul>

        </pagination-template>

      </div>
    </div>

  </div>
  <div class="b-color-100 border right-panel-grid h-82vh overflow-auto custom-area superadmin">
    <app-approve-voilation></app-approve-voilation>
  </div>
</div>